import React from "react";
import { Box, Modal, Button, Typography } from "@mui/material";
import { useRouter } from "next/router";
const modalStyle = {
  position: "absolute",
  gap: 0.5,
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  width: { xs: "85%", md: 600 },
  bgcolor: "background.paper",
  boxShadow: 24,
  justifyContent: "center",
  borderRadius: 1,
  p: 4,
};

export const NoEditModal: React.FC = () => {
  const router = useRouter();
  return (
    <Modal open={true}>
      <Box sx={modalStyle}>
        <Typography sx={{ textAlign: "center" }}>
          Editing not available on mobile
        </Typography>
        <Button
          onClick={() => router.push("/map?mode=view")}
          variant="outlined"
        >
          Go back
        </Button>
      </Box>
    </Modal>
  );
};
